export default "__VITE_ASSET__73b2cba7__"